import { CriteriaItem } from '../components/criteria-selector/criteria-selector.component';

/**
 * Shared catalog filter data
 * Used by both catalog-filters component and catalog-filters-bottom-sheet component
 */

/**
 * Sort criteria items
 */
export const SORT_ITEMS: CriteriaItem[] = [
  { id: 'org-name', label: 'charity_catalog.sort.organization_name', selected: false },
  { id: 'posted-date', label: 'charity_catalog.sort.posted_date', selected: false },
  { id: 'featured', label: 'charity_catalog.sort.featured', selected: false },
];

/**
 * Region filter items
 */
export const REGION_ITEMS: CriteriaItem[] = [
  { id: 'region-1', label: 'charity_catalog.filter.region1', selected: false },
  { id: 'region-2', label: 'charity_catalog.filter.region2', selected: false },
  { id: 'region-3', label: 'charity_catalog.filter.region3', selected: false },
  { id: 'region-4', label: 'charity_catalog.filter.region4', selected: false },
];

/**
 * Country filter items
 */
export const COUNTRY_ITEMS: CriteriaItem[] = [
  { id: 'afghanistan', label: 'charity_catalog.filter.afghanistan', selected: false },
  { id: 'algeria', label: 'charity_catalog.filter.algeria', selected: false },
  { id: 'albania', label: 'charity_catalog.filter.albania', selected: false },
  { id: 'angola', label: 'charity_catalog.filter.angola', selected: false },
  { id: 'argentina', label: 'charity_catalog.filter.argentina', selected: false },
  { id: 'australia', label: 'charity_catalog.filter.australia', selected: false },
];

/**
 * Cause filter items
 */
export const CAUSE_ITEMS: CriteriaItem[] = [
  { id: 'culture-arts', label: 'charity_catalog.filter.culture_arts', selected: false },
  { id: 'education', label: 'charity_catalog.filter.education', selected: false },
  { id: 'environmental', label: 'charity_catalog.filter.environmental', selected: false },
  { id: 'health', label: 'charity_catalog.filter.health', selected: false },
  { id: 'justice', label: 'charity_catalog.filter.justice', selected: false },
  { id: 'others', label: 'charity_catalog.filter.others', selected: false },
  { id: 'poverty', label: 'charity_catalog.filter.poverty_alleviation', selected: false },
  { id: 'christian-faith', label: 'charity_catalog.filter.christian_faith', selected: false },
];

/**
 * Category filter items
 */
export const CATEGORY_ITEMS: CriteriaItem[] = [
  { id: 'church', label: 'charity_catalog.filter.church', selected: false },
  { id: 'culture', label: 'charity_catalog.filter.culture', selected: false },
  { id: 'discipleship', label: 'charity_catalog.filter.discipleship', selected: false },
  { id: 'evangelism', label: 'charity_catalog.filter.evangelism', selected: false },
  { id: 'family-ministry', label: 'charity_catalog.filter.family_ministry', selected: false },
  { id: 'giving-generosity', label: 'charity_catalog.filter.giving_generosity', selected: false },
  { id: 'health', label: 'charity_catalog.filter.health', selected: false },
  { id: 'leadership', label: 'charity_catalog.filter.leadership_development', selected: false },
];

/**
 * Champions filter items
 */
export const CHAMPIONS_ITEMS: CriteriaItem[] = [
  { id: 'maclellan', label: 'charity_catalog.filter.maclellan_foundation', selected: false },
];
